import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { Enums, Paths } from '@utils/constants';
import { axios } from '@utils/lib';

export const checkImageQualityTmpAsync = createAsyncThunk(
  'api/checkImageQualityAsync',
  async (params: ICheckQuality, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());

    const formData = new FormData();
    formData.append('faceImage', params.file);
    formData.append('tenantId', params.tenantId);

    try {
      const { data } = await axios.request<{ isPass: boolean }>(
        Enums.HTTP_METHOD.POST,
        Paths.CHECK_IMG_QUALITY_TMP,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const registerTempAsync = createAsyncThunk(
  'api/registerTempAsync',
  async (query: IRegisterTemp, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const formData = new FormData();
    formData.append('companyName', query.companyName);
    formData.append('fullNameUser', query.fullNameUser);
    formData.append('phoneNumber', query.phoneNumber);
    formData.append('deliveryDestination', query.deliveryDestination);
    formData.append('carNumber', query.carNumber);
    formData.append('faceImage', query.faceImage);
    formData.append('tenantId', query.tenantId);
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.POST,
        Paths.PREREGISTRATION_LIST,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const getTenantIdAsync = createAsyncThunk(
  'api/getTenantIdAsync',
  async (path: string, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const data = await axios.request<ITenantRes>(
        Enums.HTTP_METHOD.GET,
        Paths.FIND_TENANT_ID.replace(':path', path)
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);
